module.exports = __webpack_public_path__ + "img/achievement_flatline.5fae13c9.svg";